import { Localized } from "@robe/core";
import { useData } from "../../hooks/useData";

interface InlineValueProps {
  value: string | Localized | undefined;
}

export const InlineValue = ({ value }: InlineValueProps) => {
  const { stringify } = useData();

  return <>{stringify(value)}</>;
};
